const changeWidth = function(el, binding, vnode) {
  const {minWidth, inputPlaceHold, subfixWidth} = binding.value;
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context.font = window.getComputedStyle(el).font;
  const metrics = context.measureText(inputPlaceHold).width;
  let originWidth = metrics + subfixWidth + 45;
  if (originWidth < minWidth) {
    el.style.width = minWidth + 'px';
  } else {
    el.style.width = originWidth + 'px';
  }

};
export default {
  inserted(el, binding, vnode) {
    changeWidth(el, binding, vnode);
  },
  update(el, binding, vnode) {
    changeWidth(el, binding, vnode);
  }
};
